import { EnumMapper } from "@indietabletop/appkit";
import { lacquer } from "../../common/common.css.ts";

export function ItemToBeRemovedWarning(props: {
  what: "GEAR" | "MOD" | "WEAPON";
}) {
  const subject = EnumMapper.from<typeof props.what>({
    GEAR: "gear is",
    MOD: "mods are",
    WEAPON: "weapons are",
  });

  return (
    <div>
      In <span className={lacquer}>Campaign Mode</span>,{" "}
      {subject.get(props.what)} lost without a refund once removed.
    </div>
  );
}

export function CannotRemoveNote(props: { what: "TREATMENT" | "REPAIR" }) {
  const subject = EnumMapper.from<typeof props.what>({
    TREATMENT: "treatments",
    REPAIR: "repairs",
  });

  return (
    <div style={{ color: "hsl(0 0% 30%)" }}>
      In <span className={lacquer}>Campaign Mode</span>,{" "}
      {subject.get(props.what)} cannot be removed once added.
    </div>
  );
}
